import React, {useContext} from "react";
import {isBoImageExtension} from "../utils/bo-show-utils.js";
import {BoShowContext} from "../context/bo-show-context.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import {getAssetPath} from "../../../../../utils/get-asset-path.js";

const BoShowAttachmentGallery = ({attachments, verifySyncUrl, titleMaker, descriptionField = true}) => {
    const {printOptions, attachesToHide, handleAttachToHide, setModalAttach} = useContext(BoShowContext);

    if (!attachments?.length) return <span className={"info"}></span>;

    return (
        <section className={"grid grid-cols-4 gap-3" + (!printOptions.image ? " print:hidden" : "")}>
            {
                attachments.map((attachment, index) => {
                    const title = titleMaker?.(attachment, index) ?? attachment?.name ?? "Arquivo";
                    const url = `${verifySyncUrl(attachment.attachId)}/${attachment.attachId}`;
                    attachment.url = url

                    return (
                        <div className={"flex flex-col gap-2 relative" + (attachesToHide.includes(attachment.attachId) ? " print:hidden" : "")} key={attachment.attachId ?? index}>
                            {
                                printOptions?.image &&
                                <InputCheckbox
                                    id={"attach-check-" + attachment.attachId}
                                    checked={!attachesToHide.includes(attachment.attachId)}
                                    label={"Exibir"}
                                    onChange={() => handleAttachToHide(attachment.attachId)}
                                    className={"absolute top-[5px] left-[10px] print:hidden"}
                                />
                            }

                            {
                                isBoImageExtension(attachment?.extension)
                                    ? (
                                        <div className={"image"} onClick={() => setModalAttach({open: true, attach: attachment})}>
                                            <img src={url} alt={title}/>
                                        </div>
                                    )
                                    : (
                                        <div className={"image"} onClick={() => setModalAttach({open: true, attach: attachment})}>
                                            <img
                                                src={getAssetPath(`img/file-types/${attachment?.name?.split(".")?.pop()}.png`)}
                                                onError={e => {
                                                    e.target.src = getAssetPath(`img/file-types/files.png`)
                                                }}
                                                alt={title}
                                            />
                                        </div>
                                    )
                            }

                            {
                                descriptionField && attachment?.description &&
                                <p>
                                    <span className={"info"}>{attachment.description}</span>
                                </p>
                            }
                        </div>
                    );
                })
            }
        </section>
    );
};

export default BoShowAttachmentGallery;
